import React from 'react';
import { Popover } from 'antd';
import { isMobileByOS } from 'externals/_tracking/dom/navigator';
import classnames from 'classnames';
import '../Popover/CSPopover.scss';

function CSPopover({
  placement,
  arrowPointAtCenter,
  overlayClassName,
  onMouseEnter,
  content,
  children,
  ariaLabel,
  ...props
}) {
  const isMobile = isMobileByOS();
  const popoverTrigger = ['hover', 'click'];
  if (!isMobile) {
    popoverTrigger.push('focus');
  }
  const popoverClass = classnames('cs-popover', overlayClassName);
  return (
    <Popover
      placement={placement}
      arrowPointAtCenter={arrowPointAtCenter}
      trigger={popoverTrigger}
      overlayClassName={popoverClass}
      onMouseEnter={onMouseEnter}
      content={content}
      {...props}
    >
      <div role="tooltip" aria-label={`Tooltip ${ariaLabel}`} tabIndex={0}>
        {children}
      </div>
    </Popover>
  );
}

export { CSPopover };
